<div [class.u-attachments-card--error]="showError" class="u-attachments-card">
	<div class="u-attachments-card__content">
		<div class="u-attachments-card__title">
			<div class="c-round u-m-right--xs">
				<img alt="Upload" src="/assets/icons/icon-sources/upload.svg" />
			</div>
			<h6>{{ title }}</h6>
		</div>

		<ng-content></ng-content>

		<button (click)="selectFile()" class="c-btn c-btn--highlight u-m-top--md" type="button">Bestand opladen</button>
		<input #uploadButton (change)="handleFileInput($event.target.files)" [id]="'upload-button-' + type" multiple type="file" />

		<ng-container *ngIf="!disableSkip">
			<tvcore-checkbox *ngIf="skipText" [control]="form.get(type)" [name]="'skip-' + type" class="u-m-top--sm">{{ skipText }}</tvcore-checkbox>
			<tvcore-checkbox *ngIf="skipTextAlt" [control]="form.get(type + 'Alt')" [name]="'skip-alt-' + type" class="u-m-top--sm">{{
				skipTextAlt
			}}</tvcore-checkbox>
		</ng-container>

		<p *ngIf="showError" class="u-text--error u-m-top--sm u-text--sm">
			<ng-container *ngIf="errorText; else defaultError"> <span class="icon-warning-circle u-text--xlg"></span> {{ errorText }} </ng-container>
			<ng-template #defaultError>
				<span class="icon-warning-circle u-text--xlg"></span> Gelieve minstens 1 bewijsstuk/document op te laden<span *ngIf="skipText">
					of de checkbox aan te vinken</span
				>.
			</ng-template>
		</p>
	</div>

	<div class="u-attachments-card__items">
		<h6>Bijlagen</h6>

		<div class="u-attachments-card__list">
			<ng-container *ngFor="let a of subsidy.attachments | tvcoreFilter: 'type':type; let i = index">
				<div *ngIf="viewAll || i < 5" class="u-attachments-card__item">
					<a [download]="a.filename" [href]="'/api12/' + subsidyType + '/' + api + '/' + subsidy.id + '/attachment/' + a.id" target="_blank">{{
						a.filename
					}}</a>
					<p (click)="deleteAttachment(a)">
						<span>verwijderen</span>
						<span class="icon-trash"></span>
					</p>
				</div>

				<div (click)="viewAll = true" *ngIf="!viewAll && i === 5" class="u-attachments-card__item">
					<button type="button">Meer tonen</button> <span class="icon-angle-down"></span>
				</div>
			</ng-container>
		</div>
	</div>
</div>
